export enum DatePickerType {
    Single_Date = 1,
    Range
}
